// extracted by mini-css-extract-plugin
module.exports = {"container":"InlineSelect_container__dWCAi","togglerLabel":"InlineSelect_togglerLabel__2P4de","togglerLabelLowercase":"InlineSelect_togglerLabelLowercase__3t0UN"};